import { PageHeader } from "@/components/app/UI";

export default function Placeholder({ title, subtitle, phase }) {
  return (
    <div data-testid={`pv-placeholder-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <PageHeader eyebrow="Purchasing" title={title} subtitle={subtitle} />
      <div className="p-4 sm:p-8">
        <div className="border-2 border-dashed border-[#E5E7EB] p-12 text-center">
          <div className="label-eyebrow !text-[#9CA3AF] mb-2">Coming in {phase}</div>
          <div className="text-sm text-[#4B5563] max-w-md mx-auto">{subtitle}</div>
        </div>
      </div>
    </div>
  );
}
